import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import {isMobileOnly} from 'react-device-detect';

const CateIconBtnBlock = styled.li`
    ${!isMobileOnly&&`
        float: left;
        width: 168px;   /* 카테고리 수 7개 1176/7*/
    `};
    // float: left;
    // width: 16.66%;
    text-align: center;
    cursor: pointer;
    height: 70px;
    ${isMobileOnly&&`
      .icon-container {
        width: 80px;
        height: 80px;
        background-color:rgba(248,248,248,1); 
        border-radius: 50%; 
        padding: 24px 13px;
        }`};
`;

const CateIconBtnHoverBlcok = styled.p`
    position: relative;
    z-index: 1;
    display: inline-block;
    &:hover {
        ::after {
            display: block;
        }
    }

    // mobile에서는 호버 이펙트 사용중지
    ::after {
        content: "";
        display: ${props => props.hoverdisp};
        position: absolute;
        top: -6px;
        right: -11px;
        width: 36px;
        height: 36px;
        background-color: #79b88a;
        border-radius: 50%;
        z-index: -1;
    }
`;

const CateIconImgBlcok = styled.img`
`;

const CateIconSpanBlock = styled.span`
    display: ${props => props.hoverdisp};//block;
    position: relative;
    margin-top: 10px;
    font-size: ${isMobileOnly?"13px":"14px"};
`;

const CateIconBtn = ({ img, text, onClick, isSelected, isCenterAlign, isForceTitle = false }) => {
    const [isHover, setIsHover] = useState(false);
    const styles = isSelected ? { display: "block", fontWeight:"600" }  : (isHover ? { display: "block", fontWeight:"600" } : (isForceTitle ? { display: "block" } :{display : "none"}));
    let imgsrc = "/assets/images/icon/" + img;

    const onMouseEnter = () => {
        setIsHover(true);
    }

    const onMouseLeave = () => {
        setIsHover(false);
    }

    return (
        <CateIconBtnBlock onClick={onClick} style = {isCenterAlign ? {display: "inline-block",float:"none"}: {}}>
            <div className="icon-container">
            <CateIconBtnHoverBlcok onMouseEnter = {onMouseEnter} onMouseLeave = {onMouseLeave} hoverdisp={isSelected ? 'block' : 'none'}>
                <CateIconImgBlcok src={imgsrc} />
            </CateIconBtnHoverBlcok>
            </div>
            <CateIconSpanBlock hoverdisp={isSelected ? 'block' : 'none'} style = {styles}>{text}</CateIconSpanBlock>
        </CateIconBtnBlock>
    );
};

export default CateIconBtn;
